import { useContext } from 'react';

import { OverrideContext } from '../context/OverrideContext';

export const useOverrideHooks = () => {
  const registry = useContext(OverrideContext);
  if (!registry) {
    throw new Error('useOverrideHooks must be used within an OverrideProvider');
  }
  return registry.createHookProxy();
};
